const validateUserName = (input) => {
  // Оставляем только буквы (a-z, A-Z) и цифры (0-9), удаляем всё остальное
  return input.replace(/[^a-zA-Z0-9]/g, '');
};

export { validateUserName };